<div class="sx-help-support" *ngIf="supportData">

  <p  *ngIf="supportData.description" [innerHTML]="supportData.description | safeHtml" appRouterLink></p>

  <div class="sx-help-support__contact-row" *ngIf="supportData.phone && supportData.phone.length > 0">
    <svg class="sx-help-support__icon">
      <use xlink:href="#baseline-phone_iphone-24px" href="#baseline-phone_iphone-24px" />
    </svg>
    <a class="sx-help-support__link" href="tel:{{ supportData.phone }}">
      {{ supportData.phone }}
    </a>
  </div>

  <div class="sx-help-support__contact-row" *ngIf="supportData.email && supportData.email.length > 0">
    <svg class="sx-help-support__icon">
      <use xlink:href="#baseline-email-24px" href="#baseline-email-24px" />
    </svg>
    <a class="sx-help-support__link" href="mailto:{{supportData.email}}">{{ supportData.email }}</a>
  </div>

</div>